import { useTranslation } from "react-i18next";
import Button from "../../Button/Button";
import IconButton from "../../IconButton/IconButton";
import styles from "../TransparentDrawer.module.scss";
import useOnClickFunctions from "../helpers/onClickFunctions";
import { useParams } from "react-router-dom";
import { useVenuesDataStore } from "@/store/useVenuesDataStore";

function PayYourBill() {
  const { t } = useTranslation();
  const { handleNavigate, handleClose } = useOnClickFunctions();
  const { restaurantId, tableId } = useParams();
  const { remainingAmount, setVenuesData } = useVenuesDataStore();

  const handlePayFullBill = () => {
    setVenuesData({
      selectedAmount: remainingAmount / 100,
      splitMethod: "custom",
    });
    handleNavigate(`/restaurants/${restaurantId}/tables/${tableId}/leave-tip`);
  };

  return (
    <div className={styles.paymentButtonsGroupWrapper}>
      <div className={styles.paymentButtonsGroupHeader}>
        <IconButton
          iconName=""
          onClick={() => {}}
          color="primary"
          variant="text"
        />
        <p className={`body-bold-large ${styles.paymentButtonsGroupTitle}`}>
          {t("transparentDrawer.title.payYourBill")}
        </p>
        <IconButton
          iconName="las la-times icon-big"
          onClick={() => handleClose()}
          color="primary"
        />
      </div>
      <Button
        onClick={() =>
          handleNavigate(
            `/restaurants/${restaurantId}/tables/${tableId}/split-the-bill`,
          )
        }
        label={t("transparentDrawer.button.splitTheBill")}
        variant="outlined"
        color="primary"
        maxWidth
        mobile={true}
      />
      <Button
        onClick={handlePayFullBill}
        label={t("transparentDrawer.button.payFullBill")}
        variant="contained"
        color="primary"
        maxWidth
        mobile={true}
      />
    </div>
  );
}

export default PayYourBill;
